import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { LogOut } from 'react-feather';
import { auth } from "shared/utils/firebase";
import { Navbar, Container, Nav, NavDropdown } from 'react-bootstrap';
import styles from './MobileNavbar.module.css';
import SmartLink from './SmartLink';
import { getAbsoluteUrl, isSameSite } from '../../utils/navigation';

function MobilenavBar(props) {
  const navigate = useNavigate();
  const isAuthenticated = props.auth ? true : false;
  const userDetails = props.userDetails || {};
  const [expanded, setExpanded] = useState(false);

  const navigateTo = (path) => {
    if (isSameSite(path)) {
      navigate(path);
    } else {
      window.location.href = getAbsoluteUrl(path);
    }
    setExpanded(false);
  };

  const handleNextButtonClick = () => {
    if (isAuthenticated) {
      // Navigate based on user role
      if (userDetails?.role === 'Admin' || userDetails?.isAdmin === true) {
        navigateTo('/admin');
      } else {
        navigateTo('/dashboard');
      }
    } else {
      navigateTo('/login');
    }
  };

  const handleLogout = async () => {
    await signOut(auth);
    setExpanded(false);
  };

  const closenavBar = () => {
    setExpanded(false);
  };


  return (
    <section className={styles.stickyTopNav}>
      <Navbar className={styles.mobileNav} bg="light" expand="lg" id="mobileNav" expanded={expanded} onToggle={setExpanded} >
        <Container>
          <Navbar.Brand as={SmartLink} to="/" onClick={closenavBar}>
            <div className={styles.navText}>
              <img
                src="/static_img/weblogo.png"
                alt="logo"
              />
            </div>
          </Navbar.Brand>
          <Navbar.Toggle>
            {isAuthenticated ? (
              <div className={styles.userAvatarWrapper}>
                <div className={styles.userAvatar}>
                  {userDetails?.name
                    ? userDetails.name.charAt(0).toUpperCase()
                    : userDetails?.email
                      ? userDetails.email.charAt(0).toUpperCase()
                      : 'U'}
                  )}
                </div>
              </div>) : (
              <div className={styles.userAvatarWrapper}>
                <div className={styles.guestAvatar}>
                  <i className="fas fa-user-circle" />
                </div>
              </div>
            )}
          </Navbar.Toggle>


          <Navbar.Collapse className=''>
            <div className={styles.navColumns}>
              <Nav className={styles.navList}>
                <Nav.Link as={SmartLink} to="/" onClick={closenavBar} className={styles.navItem}>
                  <div className={styles.navText}> <i className="fas fa-home me-2" />Home</div>
                </Nav.Link>
                <Nav.Link as={SmartLink} to="/about" onClick={closenavBar} className={styles.navItem}>
                  <div className={styles.navText}><i className="fas fa-question me-2" />About</div>
                </Nav.Link>
                <Nav.Link as={SmartLink} to="/learning" onClick={closenavBar} className={styles.navItem}>
                  <div className={styles.navText}><i className="fas fa-graduation-cap me-2" />Learning</div>
                </Nav.Link>
                <Nav.Link as={SmartLink} to="/notice" onClick={closenavBar} className={styles.navItem}>
                  <div className={styles.navText}><i className="fas fa-bell me-2" />Notice</div>
                </Nav.Link>
                <Nav.Link as={SmartLink} to="/pricing" onClick={closenavBar} className={styles.navItem}>
                  <div className={styles.navText}><i className="fas fa-dollar me-2" />Pricing</div>
                </Nav.Link>
                <Nav.Link as={SmartLink} to="/contact" onClick={closenavBar} className={styles.navItem}>
                  <div className={styles.navText}><i className="fas fa-phone me-2" />Contact</div>
                </Nav.Link>
              </Nav >

              <Nav className={styles.userColumn}>
                {isAuthenticated ? (userDetails?.role === 'Admin' || userDetails?.isAdmin === true) ? (
                  // Admin dropdown options
                  <>
                    <Nav.Link as={SmartLink} to="/admin" onClick={closenavBar} style={{ color: '#dc3545', fontWeight: '600' }}>
                      <div className={styles.navText}> <i className="fas fa-tachometer-alt me-2" />Admin Dashboard
                      </div> </Nav.Link>
                    <NavDropdown.Divider />
                    <Nav.Link as={SmartLink} to="/admin/users" onClick={closenavBar}>
                      <div className={styles.navText}> <i className="fas fa-users me-2" />User Management
                      </div> </Nav.Link>
                    <Nav.Link as={SmartLink} to="/admin/courses" onClick={closenavBar}>
                      <div className={styles.navText}> <i className="fas fa-video me-2" />Course Management
                      </div> </Nav.Link>
                    <Nav.Link as={SmartLink} to="/admin/textmodule" onClick={closenavBar}>
                      <div className={styles.navText}> <i className="fas fa-book me-2" />Read-Module Management
                      </div> </Nav.Link>
                    <Nav.Link as={SmartLink} to="/admin/projects" onClick={closenavBar}>
                      <div className={styles.navText}> <i className="fas fa-project-diagram me-2" />Project Management
                      </div> </Nav.Link>
                    <Nav.Link as={SmartLink} to="/admin/tests" onClick={closenavBar}>
                      <div className={styles.navText}> <i className="fas fa-clipboard-list me-2" />Tests Management
                      </div> </Nav.Link>
                    <Nav.Link as={SmartLink} to="/admin/events" onClick={closenavBar}>
                      <div className={styles.navText}> <i className="fas fa-calendar me-2" />Event Management
                      </div> </Nav.Link>
                    <Nav.Link as={SmartLink} to="/admin/announcements" onClick={closenavBar}>
                      <div className={styles.navText}> <i className="fas fa-bullhorn me-2" />Announcements
                      </div> </Nav.Link>
                    <Nav.Link as={SmartLink} to="/admin/jobs" onClick={closenavBar}>
                      <div className={styles.navText}> <i className="fas fa-briefcase me-2" />Job Roles
                      </div> </Nav.Link>
                    <Nav.Link as={SmartLink} to="/admin/contact-requests" onClick={closenavBar}>
                      <div className={styles.navText}> <i className="fas fa-envelope me-2" />Contact Requests
                      </div> </Nav.Link>
                    <Nav.Link as={SmartLink} to="/admin/companies" onClick={closenavBar}>
                      <div className={styles.navText}> <i className="fas fa-building me-2" />Companies
                      </div> </Nav.Link>
                    <Nav.Link as={SmartLink} to="/admin/gallery" onClick={closenavBar}>
                      <div className={styles.navText}> <i className="fas fa-images me-2" />Gallery
                      </div> </Nav.Link>
                    <Nav.Link as={SmartLink} to="/admin/profile" onClick={closenavBar}>
                      <div className={styles.navText}> <i className="fas fa-user me-2" />Admin Profile
                      </div> </Nav.Link>
                    <Nav.Link onClick={handleLogout}>
                      <LogOut size={16} className="me-2" /> Log Out
                    </Nav.Link>
                  </>
                ) : (
                  // User dropdown options (Student/Professional - Access Denied)
                  <>
                    <div className="text-center p-3 w-100">
                      <div className="text-danger fw-bold mb-2">Access Denied</div>
                      <p className="text-muted small mb-3">You do not have administrative privileges.</p>
                      <Nav.Link
                        href={window.location.hostname.includes("localhost") ? "http://localhost:3000/login" : "https://siliconlogix.in/login"}
                        className="btn btn-primary btn-sm text-white mb-2 w-100 text-center"
                        onClick={closenavBar}
                        style={{ display: 'inline-block', borderRadius: '4px' }}
                      >
                        Go to User Login
                      </Nav.Link>
                      <hr className="my-2" />
                      <Nav.Link onClick={handleLogout} className="btn btn-outline-danger btn-sm w-100 text-center d-flex align-items-center justify-content-center">
                        <LogOut size={16} className="me-2" /> Log Out
                      </Nav.Link>
                    </div>
                  </>
                )
                  : (
                    <btn className={styles.userLogin} onClick={handleNextButtonClick}> Log In </btn>
                  )
                }
              </Nav >
            </div >
          </Navbar.Collapse >
        </Container >
      </Navbar >
    </section >
  );
}

export default MobilenavBar; 